module.exports = __webpack_public_path__ + "static/media/carbon_close.f0d71c3a.svg";